import {appendAll} from "../utils/helpers";

const LAMMediaCTA = () => {
  const liquidData = JSON.parse(
    document.getElementById(`lam-media-cta-metafields`).textContent
  );

  appendAll(liquidData);
}

export default LAMMediaCTA;